import { allBlockchainCoin } from '@/assets/static/currency-list'

export default {
  activeBlockchain: allBlockchainCoin,
  riskFilter: null,
  // HISTORY_SOURCES values ('risk' | 'screening'); empty = all sources.
  sourceFilter: [],
  rangeFilter: {
    from: null,
    to: null,
  },
}
